import { ReactNode } from 'react';

import { commonUiStateSlice, useAppSelector } from '@app/app-state';

import { GrowthbookBaseProvider } from './growthbook-base.provider';

export const GrowthbookPagesProvider = ({ children }: { children: ReactNode }) => {
    const payload = useAppSelector(commonUiStateSlice.selectors.selectGrowthbookPayload);
    const forcedFeatures = useAppSelector(commonUiStateSlice.selectors.selectFt);

    return (
        <GrowthbookBaseProvider payload={payload} forcedFeatures={forcedFeatures}>
            {children}
        </GrowthbookBaseProvider>
    );
};
